import { getStorageByKey, setStorageValueByKey } from './localStorage';

const STORAGE_NOTIFY_EMPLOYEES_USER_ID = 'reclamation_notify_employees_';

export const storageNotifyEmployees = {
  get: (reclamationId, userId) =>
    getStorageByKey(`${STORAGE_NOTIFY_EMPLOYEES_USER_ID}_${reclamationId}_${userId}`),
  set: (reclamationId, userId, valueIds = []) => {
    if (!userId || !reclamationId) return;
    setStorageValueByKey(
      `${STORAGE_NOTIFY_EMPLOYEES_USER_ID}_${reclamationId}_${userId}`,
      valueIds,
    );
  },
};

export const isActionsEdit = ({ configAccess = null }) => {
  return configAccess?.reclamations?.main === 2;
};

export const isActionsArchived = ({ isPage = false, item = null, configAccess = null }) => {
  const access = configAccess?.reclamations?.main === 2;
  if (!access) {
    return false;
  }

  if (isPage) {
    return true;
  }

  return item?.can_archived;
};

export const isActionsChangeStatus = ({ configAccess }) => {
  return configAccess?.reclamations?.main === 2;
};
